export const PK_CITIES = [
  'Karachi', 'Lahore', 'Islamabad', 'Rawalpindi', 'Faisalabad', 'Multan',
  'Peshawar', 'Quetta', 'Sialkot', 'Gujranwala', 'Hyderabad', 'Bahawalpur',
  'Sargodha', 'Abbottabad', 'Sukkur', 'Larkana', 'Sheikhupura',
  'Rahim Yar Khan', 'Dera Ghazi Khan', 'Jhang',
];
